import MessageThreadContainer from './MessageThreadContainer';

export default MessageThreadContainer;



// WEBPACK FOOTER //
// ./src/components/Pages/Messages/MessageThreadContainer/index.js